// @flow

import * as ActionCable from "app/vendor/actioncable";
import throttle from "throttleit";

const cable = ActionCable.createConsumer();

if (process.env.NODE_ENV === "development") {
  ActionCable.logger.enabled = true;
}

// TODO: add a react context which can propagate the consumer instead of using
// this global module, once we know every usage of the consumer is within a
// react tree capable of using a context. Ideally switch to use-action-cable
// hooks eventually.

export default cable;

type ActionCableSubscriptionMixin = {
  initialized?: () => void,
  connected?: () => void,
  rejected?: () => void,
  disconnected?: () => void,
  received?: (data: any) => void,
};

type ReconnectBrokerSubscriptionMixin = {
  ...ActionCableSubscriptionMixin,
  reconnected: () => void,
};

// Decorates an ActionCable subscription mixin with some custom logic to allow for a `reconnected` event
export const withReconnectBroker = ({
  connected,
  reconnected,
  ...mixin
}: ReconnectBrokerSubscriptionMixin) => ({
  // We want everything else the subscription consumer passed in
  ...mixin,

  // Keep track of whether we've been connected before
  hasBeenConnected: false,

  // Our `reconnected` event can occur at most once every minute
  reconnected: throttle(reconnected, 60 * 1000),

  // NOTE: `connected` is never passed any parameters by ActionCable
  connected() {
    if (
      Features.AllowThrottledReloadsOnWebsocketConnection &&
      this.hasBeenConnected
    ) {
      this.reconnected();
    }
    // Delegate to  the subscription consumer's `connected` event if one was provided
    if (connected) {
      connected();
    }
    this.hasBeenConnected = true;
  },
});
